import { render, staticRenderFns } from "./houtai_jingru.vue?vue&type=template&id=72c5d7fc&scoped=true&"
import script from "./houtai_jingru.vue?vue&type=script&lang=js&"
export * from "./houtai_jingru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c5d7fc",
  null
  
)

export default component.exports